import Cookies from 'universal-cookie';

const cookies = new Cookies();
const names = ['accessToken', 'refreshToken'] as const;
const options = { path: '/', maxAge: 7 * 24 * 60 * 60 };
const epochKey = 'timetask:session-epoch';
const endKey = 'timetask:session-ended';
const recoveredKey = 'timetask:session-recovered';
let normalizedPath = '';

function removeScopedCookies() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    for (let i = 1; i <= parts.length; i++) {
        const path = '/' + parts.slice(0, i).join('/');
        [path, path + '/'].forEach(scope => names.forEach(name => cookies.remove(name, {path: scope})));
    }
}
function normalize() {
    const duplicate = names.some(name => document.cookie.split(';').filter(part => part.trim().startsWith(name + '=')).length > 1);
    if (normalizedPath === window.location.pathname && !duplicate) return;
    normalizedPath = window.location.pathname;
    const previous = names.map(name => cookies.get<string>(name));
    removeScopedCookies();
    // Never combine a legacy scoped token with an existing root session.
    if (names.some(name => cookies.get(name))) return;
    names.forEach((name, i) => {
        if (previous[i]) cookies.set(name, previous[i], options);
    });
}
export function getAccessToken(): string | undefined { normalize(); return cookies.get('accessToken'); }
export function getRefreshToken(): string | undefined { normalize(); return cookies.get('refreshToken'); }
export function getSessionEpoch() { return localStorage.getItem(epochKey) || ''; }
function nextEpoch() {
    const epoch = `${Date.now()}:${Math.random()}`;
    localStorage.setItem(epochKey, epoch);
    return epoch;
}
export function saveSessionTokens(token: string, refreshToken: string, userId?: string) {
    removeScopedCookies();
    if (userId) localStorage.setItem('userID', userId);
    cookies.set('accessToken', token, options);
    cookies.set('refreshToken', refreshToken, options);
}
export function startSession(token: string, refreshToken: string) { nextEpoch(); saveSessionTokens(token, refreshToken); }
function clearTokens() {
    normalizedPath = '';
    removeScopedCookies();
    names.forEach(name => cookies.remove(name, {path: '/'}));
}
export function endSession() {
    clearTokens();
    ['token', 'userID', 'authToken', 'firstName', 'firstname', 'position', 'lastName', 'lastname', 'liveRefreshUntil']
        .forEach(key => localStorage.removeItem(key));
    localStorage.setItem(endKey, nextEpoch());
    window.dispatchEvent(new Event(endKey));
}
export function subscribeSessionEnd(onEnd: () => void) {
    const onStorage = (event: StorageEvent) => {
        if (event.key === endKey && event.newValue && event.newValue === getSessionEpoch()) { clearTokens(); onEnd(); }
    };
    window.addEventListener(endKey, onEnd);
    window.addEventListener('storage', onStorage);
    return () => { window.removeEventListener(endKey, onEnd); window.removeEventListener('storage', onStorage); };
}
export function notifySessionRecovered() { window.dispatchEvent(new Event(recoveredKey)); }
export function subscribeSessionRecovered(onRecovered: () => void) {
    window.addEventListener(recoveredKey, onRecovered);
    return () => window.removeEventListener(recoveredKey, onRecovered);
}
